export default "__VITE_ASSET__7da7399f__"